











import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class DashboardItem extends Vue {
  private loading: boolean = false;

  get isLoading() {
    return this.loading;
  }

  set isLoading(loading: boolean) {
    this.loading = loading;
  }

  @Prop()
  icon!: String;

  @Prop()
  title!: String;

  @Prop()
  subTitle!: String;

  @Prop()
  text!: String;

  show() {
    this.$emit("show");
  }

  updateLoading(loading: boolean) {
    this.isLoading = loading;
  }

  async mounted() {
    // console.log("in: " + this.title)
    this.updateLoading(true);
    // await this.loadingMethod.resolve();
    this.updateLoading(false);
    // console.log("out")
  }
}
